import React from 'react';
import {  Button,  Grid, makeStyles } from '@material-ui/core';
import { useTranslation } from 'react-i18next';
import { addDays } from 'date-fns';

const useStyles = makeStyles({
  footerWrapper: {
    paddingBottom: '16px'
  }
},{ name: 'DatePickerFooter' });

/**
 * @param {function(number): void} handleMonthChange - Function to add months to the current date
 * @param {function(Date): void} onChange - Callback to set a new date (used for "reset" button)
 *
 * @returns {JSX.Element}
 */
const DatePickerFooter = ({ handleMonthChange, onChange }) => {
  const classes = useStyles();
  const { t } = useTranslation();

  return (
    <Grid
      container
      direction="column"
      justifyContent="center"
      alignItems="center"
      spacing={ 1 }
      className={ classes.footerWrapper }
    >
      <Grid item>
        <Button
          size="small"
          variant="outlined"
          color="primary"
          onClick={ () => handleMonthChange(3) }
        >
          {t('objective.dialog.calendar.threeMonths')}
        </Button>
      </Grid>
      <Grid item>
        <Button
          size="small"
          variant="outlined"
          color="primary"
          onClick={ () => handleMonthChange(6) }
        >
          {t('objective.dialog.calendar.sixMonths')}
        </Button>
      </Grid>
      <Grid item>
        <Button
          size="small"
          variant="outlined"
          color="primary"
          onClick={ () => handleMonthChange(12) }
        >
          {t('objective.dialog.calendar.twelveMonths')}
        </Button>
      </Grid>
      <Grid item>
        <Button
          size="small"
          variant="outlined"
          color="primary"
          onClick={ () => onChange(addDays(new Date(), 1)) }
        >
          {t('objective.dialog.calendar.reset')}
        </Button>
      </Grid>
    </Grid>
  );
};

export default DatePickerFooter;